module.exports = __webpack_public_path__ + "static/img/service-side.png";